import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import '../styles/Pages.css';

const MOUs = [
    { sr: 1, institution: 'Mulika Infotech Pvt. Ltd.', type: 'Industry', purpose: 'ICT, web development training and technology support', year: '2016' },
    { sr: 2, institution: 'District Police Headquarters, Ahmednagar', type: 'Government', purpose: 'Competitive Examination Guidance and career counselling', year: '2017' },
    { sr: 3, institution: 'Uva Career Academy', type: 'Private Institution', purpose: 'Placement and career guidance for students', year: '2017' },
];

function MOUPage() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › MOU</p>
                <h1>Memoranda of Understanding (MOU)</h1>
                <p>Formal partnerships with industries, institutions, and government bodies.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Our MOU Partners</h2>
                    <table className="data-table">
                        <thead><tr><th>Sr.</th><th>Institution / Organization</th><th>Type</th><th>Purpose</th><th>Year</th></tr></thead>
                        <tbody>
                            {MOUs.map(m => (
                                <tr key={m.sr}>
                                    <td>{m.sr}</td>
                                    <td style={{ fontWeight: 600 }}>{m.institution}</td>
                                    <td>{m.type}</td>
                                    <td>{m.purpose}</td>
                                    <td>{m.year}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>Benefits of MOUs</h2>
                    <ul>
                        <li>Access to industry expertise and mentorship for students.</li>
                        <li>Internship and placement opportunities through partner organizations.</li>
                        <li>Collaborative research and development projects.</li>
                        <li>Guest lectures and workshops by industry professionals.</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default MOUPage;
